var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "spotify-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Discover-2.0-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spotify-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,0 C14.326305,0 0,14.326305 0,32 C0,49.673695 14.326305,64 32,64 C49.673695,64 64,49.673695 64,32 C64,14.3284886 49.673695,0.0021835551 32,0 Z M46.6756738,46.1516206 C46.1013988,47.0949164 44.8720573,47.3896963 43.9331286,46.8154214 C36.4195155,42.223405 26.9603548,41.1862163 15.8220403,43.730058 C14.7477311,43.9767997 13.6777892,43.3042648 13.433231,42.2299556 C13.1864893,41.1556465 13.8568407,40.0857045 14.9333333,39.8411464 C27.1219379,37.0571136 37.5789833,38.2558854 46.0140566,43.4090754 C46.9529853,43.9877175 47.2521324,45.2126919 46.6756738,46.1516206 L46.6756738,46.1516206 Z M50.5907881,37.4414193 C49.8680314,38.616172 48.3308086,38.9830092 47.1582395,38.262436 C38.5593995,32.9760491 25.4449676,31.445377 15.2717844,34.5329239 C13.9529171,34.9325145 12.5598089,34.1879222 12.1580348,32.8712385 C11.7606278,31.5523712 12.5052201,30.1614466 13.8219038,29.7596725 C25.442784,26.233231 39.8913681,27.9407711 49.7675879,34.0110542 C50.9423405,34.733811 51.3135449,36.2688502 50.5907881,37.4414193 Z M50.9270556,28.3665643 C40.6119413,22.2416923 23.59768,21.678335 13.7498465,24.6654384 C12.1689526,25.1458205 10.4963494,24.2527465 10.0181508,22.6718526 C9.53995223,21.0909587 10.4308427,19.4183555 12.0139202,18.9379734 C23.3181849,15.5076083 42.1076766,16.1692255 53.9818492,23.2177414 C55.4033436,24.0627772 55.8706244,25.899147 55.0277721,27.3184579 C54.1871034,28.7421358 52.3463664,29.2116001 50.9270556,28.3665643 Z",
    id: "Shape",
    fill: "#2EBD59",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.c886479f.svg";
export { ForwardRef as ReactComponent };